/**
 * Created by Nico on 11.07.2016.
 */
define('modules/cms/nodes/NodeFormController',['modules/module', 'modules/basemodule/controllers/EntityFormController', 'settings'], function (module) {
	'use strict';
	module.controller('NodeFormController', [
		'$scope',
		'$controller',
		'BASE_TEMPLATES_PATH',
		function ($scope, $controller, BASE_TEMPLATES_PATH) {
			angular.extend(
				this,
				$controller('EntityFormController', {
					$scope: $scope,
				})
			);

			$scope.formTabs = [
				{
					label: 'Übersicht',
					template: BASE_TEMPLATES_PATH + '/cms/node/form-main.html',
					active: true,
				},
				{
					label: 'FIELDS.CONTENT',
					template: BASE_TEMPLATES_PATH + '/cms/node/form-content.html',
				},
			];
			$scope.init('Node').then(function () {
				$scope.initFinished = true;
			});

			$scope.listState = 'root.nodes';

			$scope.tinymceOptions = {
				theme: 'modern',
				height: '500',
				convert_urls: false,
				plugins: [
					'advlist autolink lists link image charmap print preview hr anchor pagebreak',
					'searchreplace wordcount visualblocks visualchars code fullscreen',
					'insertdatetime media nonbreaking save table contextmenu directionality',
					'emoticons template paste textcolor colorpicker textpattern imagetools',
					'moodiaimage',
				],
				toolbar1:
					'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link moodiaimage',
				image_advtab: true,
			};
		},
	]);
});

